// extracted by mini-css-extract-plugin
module.exports = {"groupList":"Groups_groupList__2Tp_C","groupListli":"Groups_groupListli__uCAD0","contentGroups":"Groups_contentGroups__ZjAoV","groupContainer":"Groups_groupContainer__gPMEH"};